var LeafletLayerDiff = (function () {
    function LeafletLayerDiff(remove, add) {
        this.remove = remove;
        this.add = add;
    }
    return LeafletLayerDiff;
}());
export { LeafletLayerDiff };
//# sourceMappingURL=leaflet-layer-diff.model.js.map


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/~/@asymmetrik/angular2-leaflet/dist/leaflet/layers/leaflet-layer-diff.model.js
// module id = ../../../../@asymmetrik/angular2-leaflet/dist/leaflet/layers/leaflet-layer-diff.model.js
// module chunks = 3